import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import Moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { Image } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { FaLocationArrow } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import Msgpic from "../../assets/user.png";
import Loader from "../../Components/Loader/Loader";
import { db } from "../../Firebase";
import { getUser } from "../../Utils/LocalStorage";
import { InsertChatApi } from "../API/Messages/InsertChat";

const ChatBox = ({ ToggleChat, selectedChannel, ...props }) => {
  const navigate = useNavigate();
  const parameter = useParams();
  const location = useLocation();
  const com_id = parameter?.id;
  const userId = localStorage.getItem("cityId");
  const userData = getUser();

  const BunsinessName = location?.state?.businessName || "BunsinessName";
  const ProductName = location?.state?.productName || "ProductName";
  const profileImage = location?.state?.profileImage || Msgpic;
  const firstName = location?.state?.firstName || "FirstName";
  const endUser_Id = location?.state?.eu_id || "";
  const marketplace_business_id =
    location?.state?.marketplace_business_id || "";

  const [chatMessage, setChatMessage] = useState("");
  const [allMessages, setAllMessages] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const messagesEndRef = useRef(null);

  const split_com_id = com_id?.split("_");
  const product_id = split_com_id?.[3];

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [allMessages]);

  useEffect(() => {
    if (!com_id) return;

    setAllMessages([]);

    const q = query(collection(db, com_id), orderBy("createdAt", "asc"));

    const unsub = onSnapshot(
      q,
      (snapshot) => {
        const messages = snapshot.docs.map((docSnap) => {
          const data = docSnap.data();
          return {
            id: docSnap.id,
            text: data.text || "",
            createdAt: data.createdAt,
            user_id: data.user?._id,
            user_name: data.user?.name,
            read: data.read || false,
          };
        });

        setAllMessages(messages);
      },
      (error) => {
        console.error("Firestore snapshot error:", error);
      }
    );

    return () => unsub();
  }, [com_id]);

 
  useEffect(() => {
    if (allMessages.length > 0 && com_id) {
      allMessages.forEach((msg) => {
        if (!msg.read && msg.user_id !== userData?.user_id) {
          chatUpdate(msg.id);
        }
      });
    }
  }, [allMessages, com_id]);

  const chatUpdate = async (docID) => {
    try {
      const msgRef = doc(db, com_id, docID);
      await updateDoc(msgRef, { read: true });
    } catch (err) {
      console.error("Error updating read status:", err);
    }
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    if (!chatMessage.trim() || com_id === "voucher_coupon") {
      setErrorMessage("Please enter a valid message!");
      return;
    }
    try {
      if (userId && com_id !== "voucher_coupon") {
        const newUuid = uuidv4();
        const textToSend = chatMessage;
        setChatMessage(""); 

        await addDoc(collection(db, com_id), {
          _id: newUuid,
          text: textToSend,
          createdAt: new Date(),
          user: {
            _id: userId,
            name: BunsinessName,
          },
        });

        const messageData = {
          endUser_Id,
          channel_id: com_id,
          product_id,
          help_reason: textToSend,
          product_type: 1,
          marketplace_business_id,
        };

        await InsertChattoDB(messageData);
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const InsertChattoDB = async (messageData) => {
    try {
      const MessageData = await InsertChatApi(messageData, () => {
        navigate("/");
      });
      if (MessageData?.status === 429) {
        toast.error(MessageData.message, {
          position: "top-center",
          autoClose: 6000,
          theme: "dark",
        });
      }
    } catch (err) {
      console.error("API call error:", err);
    }
  };

  const handleKeypress = (e) => {
    if (e.key === "Enter") {
      sendMessage(e);
    }
  };

  if (com_id !== "coupon" && ToggleChat === false && selectedChannel?.id !== "") {
    return (
      <>
        {loading ? <Loader /> : ""}
        <div className="chat-main mt-3">
          <div className="chat-header">
            <div className="d-flex msg-main1 msg-main2">
              <div className="msgpic">
                <Image
                  loading="lazy"
                  src={profileImage ? profileImage : Msgpic}
                  className="msgpic"
                  alt="Profile"
                />
              </div>
              <div className="msg-1">
                <p className="msg1-text1 orange_Text">{firstName}</p>
                <p className="msg1-text1">{ProductName}</p>
                <p className="msg1-text2">{BunsinessName}</p>
              </div>
            </div>
          </div>
          <div className="container bootstrap snippets bootdeys">
            <div className="col-md-12">
              <div className="panel" id="chat">
                <div className="panel-body">
                  <div className="chats">
                    {allMessages &&
                      allMessages.map((msg) => {
                        const rawTimestamp = msg.createdAt;
                        const dateObject = rawTimestamp?.toDate
                          ? rawTimestamp.toDate()
                          : new Date(rawTimestamp);

                        const isCurrentUser =
                          msg.user_id === userId &&
                          msg.user_name === BunsinessName;

                        return (
                          <div key={msg.id}>
                            {msg.text !== "" && (
                              <div
                                className={`chat ${
                                  isCurrentUser ? "" : "chat-left"
                                }`}
                              >
                                <div className="chat-body">
                                  <div className="chat-content">
                                    <p style={{ color: "black" }}>{msg.text}</p>
                                    <time className="chat-time">
                                      {Moment(dateObject).format(
                                        "DD-MMM-YY hh:mm A"
                                      )}
                                    </time>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    <div ref={messagesEndRef} />
                  </div>
                </div>
                <div className="panel-footer">
                  <form onSubmit={sendMessage}>
                    <div className="input-group">
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Control
                          type="text"
                          value={chatMessage}
                          onChange={(e) => setChatMessage(e.target.value)}
                          placeholder="Type a message..."
                          onKeyPress={handleKeypress}
                          autoComplete="off"
                        />
                        <button
                          className="btn btn-primary chat-send"
                          type="submit"
                        >
                          <FaLocationArrow />
                        </button>
                      </Form.Group>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return null;
};

export default ChatBox;